export default __webpack_public_path__ + "static/2-fe5e9f4f380d18741f23a014ce0d0f3c.png";